import React from 'react';
import Table, {
  columnType,
  tempFilteredRows,
} from '../../../components/ClearingTable/Table';
import Button from '../../../components/Buttons/Button';
import TextField from '../../../components/Textfields/TextField';
import Text from '../../../components/Typography/Text';
import { notifyInfo, notifyError } from '../../../components/Messages/Notification';
import QueryParam from '../../../services/QueryParamService';
import { IconButton, Tooltip } from '@material-ui/core';
import { Visibility as ViewIcon } from '@material-ui/icons';
import { listClearingMarginInt } from '../../../services/FeeClearingReportService';
import FeeClearingModal from '../../../components/Modals/FeeClearingModal';
import SelectMonth from '../../../components/Dropdown/SelectMonth';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteMasterAccountNo from '../../../components/AutoComplete/AutoCompleteMasterAccountNo';
import AutoCompleteBranch from '../../../components/AutoComplete/AutoCompleteBranch';
import AutoCompleteRep from '../../../components/AutoComplete/AutoCompleteRep';
import { monthNames } from '../../../lib/data/common';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';

export default function FeeClearing() {
  var currentDate = new Date();
  var previousMonth = currentDate.getMonth();

  const [rows, setRows] = React.useState([]);
  const [rowData, setRowData] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [pagination, setPagination] = React.useState({});
  const [totalRows, setTotalRows] = React.useState(0);
  const [previousRows, setPreviousRows] = React.useState(0);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      month: monthNames[previousMonth],
      year: currentDate.getFullYear()?.toString(),
      correspondent: '',
      branch: '',
      masterAccountNo: '',
      rep: '',
      feeType: '',
      status: '',
    })
  );
  const [openModal, setOpenModal] = React.useState(false);

  // Table Settings
  const columns = [
    {
      name: '',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div align={'left'} className="grd-row" style={{ margin: 0, padding: 0 }}>
              <div align={'left'} className="grd-cell-none">
                <IconButton
                  aria-label="view"
                  onClick={() => {
                    setRowData(tempFilteredRows[dataIndex]);
                    setOpenModal(true);
                  }}
                >
                  <ViewIcon />
                </IconButton>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'rep',
      label: 'Rep',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'month',
      label: 'Month',
    },
    {
      name: 'year',
      label: 'Year',
    },
    {
      name: 'recurringFee',
      label: 'Recurring Fee',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'qty',
      label: 'Qty',
      type: columnType.quantity,
    },
    {
      name: 'rate',
      label: 'Rate',
      type: columnType.price,
    },
    {
      name: 'grossAmt',
      label: 'Gross Amount',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'minCharge',
      label: 'Minimum Charge',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'totalCharge',
      label: 'Total Charge',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'chargeBy',
      label: 'Charge By',
    },
    {
      name: 'feeType',
      label: 'Fee Type',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'contraAccountNo',
      label: 'Contra Account No',
    },
    {
      name: 'contraCorrespondent',
      label: 'Contra Correspondent',
    },
    {
      name: 'status',
      label: 'Status',
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    responsive: 'standard',
    selectableRows: 'none',
    serverSide: true,
  };
  // End Table SettingsgetSystemDate

  const init = async () => {
    const searchParameters = localStorage.getItem('search_data');

    const { correspondent, branch, masterAccountNo, rep, month, year } = searchParameters
      ? JSON.parse(searchParameters)
      : searchData;

    setSearchData({
      ...searchData,
      month: month ? month : monthNames[previousMonth],
      year: year ? year : currentDate.getFullYear(),
      correspondent: correspondent ? correspondent : '',
      branch: branch ? branch : '',
      masterAccountNo: masterAccountNo ? masterAccountNo : '',
      rep: rep ? rep : '',
    });
    if (searchData.fromDate && searchData.toDate) return;
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async (paginationChange) => {
    try {
      setLoading(true);
      QueryParam.set(searchData);
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };
      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }
      if (paginationChange !== true) {
        paginationCopy.filterNames = [];
        paginationCopy.filterValues = [];
      }
      const data = await listClearingMarginInt(searchData, paginationCopy);
      let rowsCopy = data?.clearingMarginIntsList;
      setSearchDataCsv(searchData);
      setTotalRows(data?.summary.totalRows);
      setPreviousRows(totalRows);
      setRows(rowsCopy);

      notifyInfo(data?.clearingMarginIntsList.length + ' search results.');
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const getCsvData = async () => {
    if (totalRows === 0) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };
    const data = await listClearingMarginInt(searchDataCsv, paginationCopy);

    return data?.clearingMarginIntsList;
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Fee Recurring" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectMonth
              name="month"
              label="Month"
              placeholder="Month"
              type="Month"
              value={searchData.month}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <TextField
              max={4}
              name="year"
              label="Year"
              placeholder="Year"
              type="text"
              value={searchData.year}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectSystemCode
              name="feeType"
              label="Fee Type"
              placeholder="Blank"
              type="Fee Type"
              subType="Monthly"
              value={searchData.feeType}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteCorrespondent
              name="correspondent"
              value={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteMasterAccountNo
              name="masterAccountNo"
              label="Master Account No"
              freeSolo={true}
              value={searchData.masterAccountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            ></AutoCompleteMasterAccountNo>
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteBranch
              name="branch"
              value={searchData.branch}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteRep
              name="rep"
              value={searchData.rep}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              placeholder="Blank"
              name="status"
              label="Status"
              type="Status"
              subType="Recurring Fee"
              value={searchData.status}
              onChange={handleSearchDataChange}
            ></SelectSystemCode>
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Fee Recurring Report'}
          data={rows}
          columns={columns}
          options={options}
          getCsvData={getCsvData}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
        />
        {openModal && (
          <FeeClearingModal open={openModal} close={closeModal} data={rowData} />
        )}
      </div>
    </form>
  );
}
